import { render, staticRenderFns } from "./CustomersSettingIndex.vue?vue&type=template&id=0a9a3a6d&"
import script from "./CustomersSettingIndex.vue?vue&type=script&lang=js&"
export * from "./CustomersSettingIndex.vue?vue&type=script&lang=js&"
import style0 from "./CustomersSettingIndex.vue?vue&type=style&index=0&id=0a9a3a6d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports